import { mixServerConfig } from '@/config';
import { notificationPostmessager } from './notificationPostmessager';
import { pushPopReport } from '@/api/mixServer';
import store from '@/store';
import { Toast } from 'vant';
import statisServer from '@/server/statis'
import { getPhpNow } from '@/utils';

export const notificationAcceptMessager = {
  // 弹窗如果有消息提醒需要延迟关闭
  closeDialogTimer: null,

  // 接受通知中心窗口传递的消息
  acceptNoticationMessage() {
    window.addEventListener('message', e => {
      const payload = typeof e.data === 'string' ? { action: e.data } : e.data || {};
      if (!payload.isLnNotifacation) return; // 只处理来自通知中心的消息
      notificationPostmessager.log('H5SDK接收消息', payload);
      const { action, data } = payload;
      // 统计sdk上报参数
      switch (action) {
        // 通知中心弹出弹窗
        case 'NOTIFICATION_SHIFT_DIALOG':
          this.handleShiftDialog(payload.data);
          break;
        // 通知中心贴脸图-打开
        case 'NOTIFICATION_OPEN_PUSH': {
          const { rule_id } = payload.data;
          if (rule_id) {
            this.reportPushPop({
              type: 4,
              rule_id
            });
          }
          try {
            statisServer.pushPopReportEvent([{fu_uid: store.state.saveRoleInfo.fu_uid, ln_uid: store.state.saveRoleInfo.ln_uid, role_id: store.state.saveRoleInfo.role_id, server_id: store.state.saveRoleInfo.server_id, event_time: getPhpNow()}], 'browse_popup');
          } catch (error) {
            console.log(error)
          }
        }
        // 通知中心贴脸图-关闭
        case 'NOTIFICATION_CLOSE_PUSH':
          this.closePushPop(payload);
          break;
        // 通知中心贴脸图-点击链接
        case 'NOTIFICATION_CLICK_PUSH':
          this.clickPushPop(payload);
          break;
        // 通知中心弹窗-打开链接
        case 'NOTIFICATION_OPEN_LINK':
          this.openLink(data.link);
          break;
        // 通知中心弹窗-打开红包悬浮窗
        case 'NOTIFICATION_OPEN_FLOW':
          store.commit('SET_IS_OPEN_REBATE', true);
          break;
        // 通知中心弹窗-跳转APP
        case 'url_scheme': {
          try {
            const { url_scheme } = data;
            location.href = url_scheme;
          } catch (error) {
            Toast('跳转APP失败:', JSON.stringify(error));
          }
          break;
        }
        default:
          break;
      }
    });
  },
  // 通知中心弹出弹窗
  async handleShiftDialog(data) {
    const notificationIframe = notificationPostmessager.getNotificationIframe();
    const { currentDialog, delayDuration } = data;
    const isShowIframe = !!currentDialog;
    const zIndex = isShowIframe ? '2010' : '-1'; //支付窗口为2020，层级在支付窗口下面
    const setZIndex = () => (notificationIframe.style.zIndex = zIndex);

    if (isShowIframe) {
      // 弹出红包时显示iframe
      setZIndex();
      // 弹出红包时清除计时器
      clearTimeout(this.closeDialogTimer);
    } else {
      // 关闭红包时关闭iframe

      // 如果需要延迟关闭弹窗
      if (delayDuration) {
        this.closeDialogTimer = setTimeout(() => {
          setZIndex();
        }, delayDuration);
      } else {
        // 否则直接关闭
        setZIndex();
      }
    }
  },

  // 贴脸图-关闭
  closePushPop(payload) {
    const { url, rule_id, push_close_type, isCheck } = payload.data;
    if (!url) {
      this.reportPushPop({
        type: 3,
        rule_id
      });
    }
    if (push_close_type != 0 && url) {
      if (isCheck) {
        this.reportPushPop({
          type: push_close_type,
          rule_id
        });
      }
    }
    if (push_close_type != 0 && !url) {
      if (isCheck) {
        this.reportPushPop({
          type: push_close_type,
          rule_id
        });
      } else {
        this.reportPushPop({
          type: 3,
          rule_id
        });
      }
    }
  },
  // 贴脸图-点击
  clickPushPop(payload) {
    const { url, rule_id } = payload.data;
    if (url) {
      this.reportPushPop({
        type: 0,
        rule_id
      });
      this.openLink(url);
    }
    try {
      statisServer.pushPopReportEvent([{fu_uid: store.state.saveRoleInfo.fu_uid, ln_uid: store.state.saveRoleInfo.ln_uid, role_id: store.state.saveRoleInfo.role_id, server_id: store.state.saveRoleInfo.server_id, event_time: getPhpNow()}], 'click_popup');
    } catch (error) {
      console.log(error)
    }
  },
  // 跳转url-优先调苹果的方法,不支持则使用浏览器打开
  openLink(url) {
    try {
      window.webkit.messageHandlers['receiveUrlData'].postMessage({
        params: [url]
      });
    } catch (err) {
      console.log(err, '浏览器不支持跳转');
      window.open(url, '_blank');
    }
  },
  // 贴脸图-点击上报
  async reportPushPop(payload) {
    const { type, rule_id } = payload;
    const params = {
      access_token: mixServerConfig.access_token,
      type,
      rule_id
    };
    await pushPopReport(params);
  }
};
